/* ============================================================
   Apolnus 高級微互動(原生重做,參考 reactbits)
   TiltedCard + GlareHover(卡片) / Magnet(按鈕) / 游標拖尾光暈(全頁)
   全部供評估;reduced-motion 時全關。
   ============================================================ */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* 只在有滑鼠的桌面裝置執行游標特效;手機/觸控完全跳過(省 GPU/CPU) */
  if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
  var EASE_OUT = 'transform .5s cubic-bezier(.22,1,.36,1)';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    /* ---- Tilt + Glare on cards ---- */
    var cardSel = '.onex-car__slide, .product-card, .aplx__card';
    Array.prototype.forEach.call(document.querySelectorAll(cardSel), function (card) {
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.setAttribute('data-fx-tilt', '');
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transition = 'transform .12s ease';
        card.style.transform = 'perspective(900px) rotateX(' + (-py * 4).toFixed(2) + 'deg) rotateY(' + (px * 4).toFixed(2) + 'deg)';
      });
      card.addEventListener('pointerleave', function () {
        card.style.transition = EASE_OUT;
        card.style.transform = '';
      });
    });

    /* ---- Magnet on buttons ---- */
    Array.prototype.forEach.call(document.querySelectorAll('.onex-cta, .aplx__submit, .policy-line-btn, .faqx__cta-btn'), function (btn) {
      btn.setAttribute('data-fx-magnet', '');
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.transition = 'transform .12s ease';
        btn.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * 0.3).toFixed(1) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * 0.4).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.transition = EASE_OUT;
        btn.style.transform = '';
      });
    });

    /* ---- Cursor trailing glow (whole page) ---- */
    var glow = document.createElement('div'); glow.className = 'onex-cursor-glow';
    document.body.appendChild(glow);
    var tx = window.innerWidth / 2, ty = window.innerHeight / 2, cx = tx, cy = ty, on = false;
    window.addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!on) { on = true; glow.style.opacity = '1'; }
    }, { passive: true });
    (function loop() {
      cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
      glow.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
  });
})();
